import React, {useEffect, useState} from "react";
import {getJSON} from "../api.js";
import {LoadingState, ErrorState} from "./LoadingState.jsx";
import {StrategiesTable} from "./StrategiesTable.jsx";
import {WarningsNotice} from "./WarningsNotice.jsx";

export function StrategiesPage({search, analysisWindow, refreshKey, onRefreshed}) {
    const [state, setState] = useState({loading: true, error: null, data: null});
    useEffect(() => {
        let cancelled = false;
        setState({loading: true, error: null, data: null});
        const params = new URLSearchParams({window: analysisWindow});
        if (search.trim()) params.set("query", search.trim());
        getJSON(`/api/strategies?${params}`)
            .then((data) => {
                if (!cancelled) {
                    setState({loading: false, error: null, data});
                    onRefreshed(`Snapshot refreshed · ${data.window.toUpperCase()} analysis · ${data.strategies.length} matching strategies`);
                }
            })
            .catch((error) => {
                if (!cancelled) setState({loading: false, error, data: null});
            });
        return () => {
            cancelled = true;
        };
    }, [search, analysisWindow, refreshKey, onRefreshed]);
    if (state.loading) return <LoadingState/>;
    if (state.error) return <ErrorState error={state.error}/>;
    return (
        <section className="section panel">
            <div className="panel-head section-head">
                <div><h2>Strategies</h2></div>
                <div className="subtle">
                    {state.data.strategies.length}
                    {" "}
                    matching strategies
                </div>
            </div>
            <WarningsNotice warnings={state.data.warnings}/>
            <StrategiesTable strategies={state.data.strategies}/>
        </section>
    );
}
